let transitionInProgress = false;
const transitionListeners = new Set<() => void>();

export function isAccountContextTransitionInProgress(): boolean {
  return transitionInProgress;
}

export function subscribeToAccountContextTransition(listener: () => void): () => void {
  transitionListeners.add(listener);
  return () => transitionListeners.delete(listener);
}

export function beginAccountContextTransition(): void {
  setTransitionInProgress(true);
}

export function finishAccountContextTransition(): void {
  setTransitionInProgress(false);
}

function setTransitionInProgress(inProgress: boolean): void {
  if (transitionInProgress === inProgress) {
    return;
  }
  transitionInProgress = inProgress;
  transitionListeners.forEach((listener) => listener());
}
